import React from "react";
import { useRouteError, Link } from "react-router-dom";

const ErrorPage = () => {
  const error = useRouteError();
  console.error(error);

  return (
    <div className="h-screen w-full flex flex-col items-center justify-center bg-gray-50 text-center p-6">
      <h1 className="text-4xl font-bold text-red-500">Oops!</h1>
      <p className="mt-3 text-lg text-gray-700">
        Something went wrong. Please check your internet connection or try again.
      </p>

      {/* Show error status/message if available */}
      {error && (
        <p className="mt-2 text-gray-500 text-sm">
          {error.statusText || error.message}
        </p>
      )}

      <Link
        to="/"
        className="mt-6 px-6 py-3 bg-orange-400 text-white rounded-lg hover:bg-orange-500 transition"
      >
        Go Back Home
      </Link>
    </div>
  );
};

export default ErrorPage;
